import React, { useState } from "react";

export default function Slider({
  quesId,
  min,
  max,
  step,
  onValueChange,
  ctrlName,
  value,
}) {
  const [sliderValue, setSliderValue] = useState(value ? value : min);

  const handleSliderChange = (event) => {
    const newValue = parseFloat(event.target.value);
    setSliderValue(newValue);
    onValueChange(quesId, newValue, ctrlName, 0);
  };

  return (
    <div>
      {onValueChange && (
        <input
          type="range"
          id="slider"
          name="slider"
          className="form-control"
          min={min}
          max={max}
          step={step}
          value={sliderValue}
          onChange={handleSliderChange}
        />
      )}
      {!onValueChange && (
        <input
          type="range"
          id="slider"
          name="slider"
          className="form-control"
          min={min}
          max={max}
          step={step}
          value={sliderValue}
        />
      )}
      <p className="small mt-2">Selected Value: {sliderValue}</p>
    </div>
  );
}
